export default (round) => {
    if (!round) return false;

    const { canChooseType } = round;

    return canChooseType === true;
};
